import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { environment } from '@base/environments/environment';
import { Constants } from '@base/src/app/models/constants';
import { DialogEvent } from '@base/src/app/models/dialog-event.model';
import { QRIcon } from '@base/src/app/models/qr-icon.model';

@Component({
  selector: 'app-rendition-warning-for-invalid-caps-invoices',
  templateUrl: './rendition-warning-for-invalid-caps-invoices.component.html',
  styleUrls: ['./rendition-warning-for-invalid-caps-invoices.component.scss'],
})
export class RenditionWarningForInvalidCapsInvoicesComponent implements OnInit {
  @Output() dialogChange: EventEmitter<DialogEvent> =
    new EventEmitter<DialogEvent>();
  value: any;
  address = '';
  id = 0;
  listAgents: string[] = [];

  readonly ICON_WARNING = Constants.ICONS.WARNING;
  readonly ICON_COLOR_WHITE = QRIcon.COLOR_WHITE;

  NODE = environment.node;
  NODE_DO = Constants.TENANT_ID_DO;

  ngOnInit(): void {
    if (this.value.dto) {
      if (this.value?.dto.seller)
        this.listAgents.push(
          `agente ${this.NODE === this.NODE_DO ? 'captador' : 'vendedor'}`,
        );
      if (this.value?.dto.buyer)
        this.listAgents.push(
          `agente ${this.NODE === this.NODE_DO ? 'vendedor' : 'comprador'}`,
        );
      if (this.value?.dto.sellerReferred)
        if (this.value?.dto.sellerReferred)
          this.listAgents.push(
            `referido ${this.NODE === this.NODE_DO ? 'captador' : 'vendedor'}`,
          );
      if (this.value?.dto.buyerReferred)
        this.listAgents.push(
          `referido ${this.NODE === this.NODE_DO ? 'vendedor' : 'comprador'}`,
        );
      if (this.value?.dto.referidoACobrar)
        this.listAgents.push('referido a cobrar');
    }
  }
}
